module.exports = __webpack_public_path__ + "img/arrow_left_disabled.b903c22d.svg";